export default "__VITE_ASSET__FYqykSyq__"